import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useBranding } from "../lib/branding";

/** Public header + nav shell wrapping every page. Branding (logo/name) comes from
 *  /settings; the "My requests" link only shows when signed in. */
export function Layout() {
  const { status, signOut } = useAuth();
  const { settings, name } = useBranding();
  const logoUrl = settings.branding.logo_url;
  const supportEmail = settings.branding.support_email?.trim();
  const isAuthed = status === "authenticated";

  return (
    <div className="portal">
      <header className="site-header">
        <div className="site-header-inner">
          <NavLink to="/" className="brand" aria-label="Home">
            {logoUrl ? (
              <img src={logoUrl} alt="" className="brand-logo" />
            ) : (
              <span className="brand-mark" aria-hidden="true">
                ◆
              </span>
            )}
            <span className="brand-name">{name}</span>
          </NavLink>

          <nav className="site-nav" aria-label="Primary">
            <NavLink to="/kb" className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}>
              Knowledge base
            </NavLink>
            {isAuthed ? (
              <>
                <NavLink
                  to="/tickets"
                  className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                >
                  My requests
                </NavLink>
                <button className="btn small ghost" onClick={signOut}>
                  Sign out
                </button>
              </>
            ) : (
              <NavLink
                to="/signin"
                className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
              >
                Sign in
              </NavLink>
            )}
          </nav>
        </div>
      </header>

      <main className="site-main">
        <div className="container">
          <Outlet />
        </div>
      </main>

      <footer className="site-footer">
        <div className="container">
          {supportEmail ? (
            <span className="faint">
              Need help? <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
              {" · "}
            </span>
          ) : null}
          <span className="faint">Powered by ActionConnect</span>
        </div>
      </footer>
    </div>
  );
}
